import { batch } from 'react-redux'
import { customizeError } from '@chilecompra/react-kit'
import { makeActionCreator } from '../../config/store/utils'
import { publishQuoteRequest } from '../../services/quote'
import { onSaveRoughCopyError } from '../QuoteStepTwo/QuoteStepTwo.actions'
import { onOpenQuoteRequestPublishedErrorDialog } from '../QuoteRequestPublishedErrorDialog/QuoteRequestPublishedErrorDialog.actions'

export const SHOW_PUBLISH_QUOTE_DIALOG = 'SHOW_PUBLISH_QUOTE_DIALOG'
export const onOpenPublishQuoteDialog = makeActionCreator(SHOW_PUBLISH_QUOTE_DIALOG, {})

export const CLOSE_PUBLISH_QUOTE_DIALOG = 'CLOSE_PUBLISH_QUOTE_DIALOG'
export const onClosePublishQuoteDialog = makeActionCreator(CLOSE_PUBLISH_QUOTE_DIALOG, {})

export const USER_PUBLICATION_QUOTE_CONFIRMED = 'USER_PUBLICATION_QUOTE_CONFIRMED'
export const onUserPublicationQuoteConfirmed = makeActionCreator(USER_PUBLICATION_QUOTE_CONFIRMED, {})

export const USER_PUBLISH_QUOTE_CONFIRM = 'USER_PUBLISH_QUOTE_CONFIRM'
export const onUserPublishQuoteConfirm = makeActionCreator(USER_PUBLISH_QUOTE_CONFIRM, {})

export const PUBLISH_QUOTE_REQUEST = 'PUBLISH_QUOTE_REQUEST'
export const PUBLISH_QUOTE_REQUEST_ERROR = 'PUBLISH_QUOTE_REQUEST_ERROR'
export const PUBLISH_QUOTE_REQUEST_SUCCESS = 'PUBLISH_QUOTE_REQUEST_SUCCESS'
export const onPublishQuoteRequest = makeActionCreator(PUBLISH_QUOTE_REQUEST)
export const onPublishQuoteRequestError = makeActionCreator(PUBLISH_QUOTE_REQUEST_ERROR, 'payload')
export const onPublishQuoteRequestSuccess = makeActionCreator(PUBLISH_QUOTE_REQUEST_SUCCESS, 'payload')
export const onPublishQuoteRequestThunk = payload => async (dispatch, getState) => {
  dispatch(onPublishQuoteRequest())

  try {
    const { productsSaved: products } = getState().addProductsService
    const {
      finesPenalties = 0,
      companySizeFilter = 0,
      filterRegionCode = -1,
      filterRegionNotification = 0,
      sellersAdded,
      isEnvironmental,
      isSocialEconomic
    } = getState().quoteStepTwo

    const sellersAddedDni = sellersAdded?.map(seller => seller.dni) || []

    const { data } = await publishQuoteRequest({
      code: payload.quoteCode,
      companySizeFilter,
      filterRegionCode,
      filterRegionNotification,
      finesPenalties,
      products,
      sellersAddedDni,
      isEnvironmental: isEnvironmental === 'yes',
      isSocialEconomic: isSocialEconomic === 'yes'
    })

    return batch(() => {
      dispatch(onPublishQuoteRequestSuccess())
      dispatch(onClosePublishQuoteDialog())
      payload.callback({ quoteEffectiveDays: data?.payload?.diasVigencia || '10' })
    })
  } catch (error) {
    const err = error.originalError.response.data.errores.map(error => ({
      code: error.codigo,
      description: error.descripcion
    }))

    return batch(() => {
      dispatch(
        onPublishQuoteRequestError({
          error: customizeError({
            originalError: error?.originalError,
            code: error?.code,
            reason: 'SOMETHING_WENT_WRONG_ERROR'
          }).toObject()
        })
      )
      dispatch(onOpenQuoteRequestPublishedErrorDialog())
      dispatch(onSaveRoughCopyError({ error: err }))
    })
  }
}
